import { useIsClient } from '~/lib/hooks/useIsClient';

interface UseSafeMailtoOptions {
  subject?: string;
}

export const useSafeMailto = (
  email?: string | null,
  { subject = '' }: UseSafeMailtoOptions = {}
) => {
  const isClient = useIsClient();

  if (isClient && email) {
    const params = new URLSearchParams({ subject });

    return () => window.open(`mailto:${email}?${params.toString()}`, '_blank');
  }

  return () => void 0;
};
